import { api } from "../api";
import { IObjectResponse, ISvodObjectResponse } from "./type";

export const sheetsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSheetObject: build.mutation<IObjectResponse, void>({
      query: () => ({
        url: "/finance/sheets/object",
      }),
    }),
    getSheetSvodObject: build.mutation<ISvodObjectResponse, void>({
      query: () => ({
        url: "/finance/sheets/svod-object",
      }),
    }),
  }),
});

export const {
  useGetSheetObjectMutation,
  useGetSheetSvodObjectMutation,
} = sheetsApi;
